<template>
  <!-- custom-form-common-service .cfcs -->
  <div class="cfcs">
    <div class="my-brand">
      <div class="my-brand-l">{{fieldData.Value}}:</div>
      <div class="my-brand-r">
        <Poptip
          placement="bottom-start"
          width="232px"
          v-model="popVisible" 
        >
          <Button icon="ios-add" type="dashed">新增</Button>
          <div class="my-brand-add" slot="content">
            <div class="top">
              选择服务
              <span>（可多选）</span>
            </div>
            <div class="content">
              <div
                class="my-brand-item"
                v-for="(item, index) in chooseTag"
                :key="'chooseTag' + index"
                @click="setTagActive(index)"
                :class="{active: item.active}"
              >
                {{item.value}}
              </div>
            </div>
            <div class="bottom">
              <span @click="popVisible=false">取消</span>
              <span class="plus" @click="handleAdd()">添加</span>
            </div>
          </div>
        </Poptip>
        <br /> 
        <template v-if="tag && tag.length">
          <Tag
            v-for="(item, index) in tag"
            :key="'tag' + index"
            :name="item.value"
            closable
            @on-close="handleClose(item, index)"
          >
            {{ item.value }}
          </Tag>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  // 领域类型 - 服务范围
  name: "custom-form-common-service",
  props: {
    field: {
      type: Object,
      default: { List: [], TypeId: 2, Value: "服务范围" }
    }
  },
  model: {
    prop: "field",
    event: "sendField"
  },
  data() {
    return {
      fieldData: { List: [], TypeId: 2, Value: "服务范围" },
      tag: [],
      popVisible: false, // 显示选择tag
      chooseTag: [
        // 选择的tag列表
      ],
      // 0=授权渠道
      // 1=招募地区
      // 2=服务范围
      // 3=代工品类
      // 4=擅长领域
      // 5=合作渠道
      // 8=服务地区
      type: 2
    };
  },
  watch: {
    tag(val, oldVal) {
      if (val) {
        this.fieldData.List = this.transfromData(this.tag);
        this.$emit("sendField", this.fieldData);
        this.$emit("refresh");
      }
    }
  },
  async created() {
    let data = await this.getActionType(this.type);
    data.map(c => (c.active = false));
    this.chooseTag = data;
    this.init();
  },
  methods: {
    ...mapActions({
      getActionType: "companyModule/getActionType"
    }),
    init() { 
      if (this.field && this.field.List) {
        let arr = [];
        if (this.chooseTag && this.chooseTag.length) {
          this.chooseTag.map(c => { 
            this.field.List.forEach(v => {
              if (c.value === v.Value) {
                c.active = true;
                arr.push(c);
              }
            });
          });
        }
        this.tag = arr;
      }
    },
    handleAdd() {
      let obj = {};
      let arr = [];
      this.tag.forEach(v => {
        obj[v.value] = 1;
      });
      this.chooseTag.forEach(c => {
        if (c.active && obj[c.num] !== 1) {
          arr.push(c);
        }
      }); 
      this.tag = arr;   
      this.popVisible = false;
    },
    handleClose(item, index) {
      this.tag.splice(index, 1);
      this.chooseTag.map(c => {
        if (c.value === item.value) {
          c.active = false;
        }
      });
    }, 
    setTagActive(index) {
      this.chooseTag[index].active = true;
    }, 
    transfromData(data) {
      // 将数据转换成对应匹配的数据
      let arr = [];
      data.forEach(c => {
        let Arr = {
          TypeId: c.typeId, 
          Value: c.value
        };
        arr.push(Arr);
      });
      return arr;
    }
  }
};
</script>

<style lang="scss">
.my-brand {
  display: flex;
  &-l {
    width: 84px;
    font-size: 14px;
    color: #333;
  }
  &-r {
    flex: 1;
  }
  &-add {
    width: 250px;
    height: 200px;
    background-color: #fff;
    border-radius: 5px;
    .top {
      padding: 10px 15px;
      border-bottom: 1px solid #f2f2f2;
      color: #333;
      span {
        color: #808080;
        font-size: 12px;
      }
    }
    .content {
      height: 118px;
      width: 250px;
      overflow: auto;
      border-bottom: 1px solid #f2f2f2;
      padding: 10px;
    }
    .bottom {
      display: flex;
      justify-content: flex-end;
      line-height: 40px;
      color: #333;
      span {
        font-size: 14px;
        padding: 0 20px;
        display: inline-block;
        cursor: pointer;
        &.plus {
          color: #178fff;
        }
      }
    }
  }
  &-item {
    padding: 2px 6px;
    border-radius: 5px;
    border: 1px solid #7f7f7f;
    color: #808080;
    margin-bottom: 14px;
    margin-right: 20px;
    font-weight: bold;
    max-width: 195px;
    min-width: 78px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    display: inline-block;
    float: left;
    &:hover,
    &.active {
      border: solid 1px #178fff;
      color: #178fff;
    }
    .iconfont {
      font-size: 18px;
      position: relative;
      top: 2px;
    }
  }
}
.my-brand {
  .ivu-poptip-popper {
    padding: 0;
    height: 200px;
    background-color: #fff;
    box-shadow: 0px 5px 20px 0px rgba(53, 153, 231, 0.2);
    border-radius: 5px !important;
  }
  .ivu-poptip-body {
    padding: 0;
  }
  .ivu-poptip-arrow {
    display: none;
  }
  .ivu-poptip-inner {
    box-shadow: none;
  }
  .ivu-btn {
    font-size: 14px;
  }
  .ivu-tag {
    height: 32px;
    line-height: 32px;
    margin: 10px 10px 0 0;
    background: #fff;
    border: solid 1px #178fff;
    color: #178fff;
    font-size: 14px; 
    .iconfont {
      position: relative;
      top: 2px;
    }
    .ivu-tag-text {
      position: relative;
      top: -2px;
      color: #178fff;
    }
    .ivu-icon {
      position: relative;
      top: -3px;
      color: #178fff;
    }
  }
}
</style>
